module.exports = __webpack_public_path__ + "img/Slice3-min.317b7843.png";